import { GET_MAP, GET_MAP_SUCCESS, GET_MAP_ERROR} from './actionTypes';

const initialState = {
    errorGetMap: "",
    loadingGetMap: false,
    map: null,
    successGetMap: ""
}

const getMap = (state = initialState, action) => {
    switch (action.type) {
        case GET_MAP:
            state = {
                ...state,
                loadingGetMap: true
            }
            break;
        case GET_MAP_SUCCESS:
            state = {
                ...state,
                loadingGetMap: false,
                map: action.payload.map, 
                successGetMap: action.payload.message
            }
            break;
        case GET_MAP_ERROR:
            state = { ...state, errorGetMap: action.payload, loadingGetMap: false };
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default getMap;